<template>
    <section
        id="prebuild-section"
        :class="`prebuild-section ${sectionData.className}`"
        :style="{backgroundImage: `url(${backgroundImage})`}"
    >
        <div class="prebuild-section-content">
            <h3 class="prebuild-section-title" v-html="sectionData.title" />
            <p class="prebuild-section-sub">{{ sectionData.body | stripTags }}</p>
            <button
                class="prebuild-section-button btn btn-purple"
                @click="onBuyNow"
            >
                Buy Now
            </button>
        </div>
        <div class="prebuild-section-image">
            <img :src="sectionData.logo_url" :alt="`${sectionData.title} Build`">
        </div>
    </section>
</template>

<script>
import { heapAnalytics } from "@u/mixins.js";

export default {
    name: "PrebuildPcSection",
    mixins: [
        heapAnalytics
    ],
    props: {
        sectionData: {
            type: Object,
            required: true
        },
        shouldUseMobileBackground: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        backgroundImage() {
            return this.shouldUseMobileBackground ? this.sectionData.mobileBackground : this.sectionData.background_url;
        }
    },
    methods: {
        onBuyNow() {
            this.trackAll(`Client: Click ${this.sectionData.trackEvent} Banner BuyNow`);

            if (this.sectionData.landingPageRoute.includes("starter-pc")) {
                localStorage.setItem("init-start-cart", 1);
                localStorage.setItem("starter-pc-index", this.sectionData.landingPageRoute == "starter-pc" ? 0 : 1);
                this.$store.dispatch("StarterPc/resetCart");
            }

            this.$router.push({
                name: this.sectionData.landingPageRoute,
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.prebuild-section {
    margin-right: -15px;
    margin-left: -15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 75px;
    overflow: hidden;
    background-size: cover;

    @media screen and (max-width: 599px) {
        background-repeat: no-repeat !important;
        background-size: cover !important;
        justify-content: center;
        height: 230px;
        justify-content: center;
        padding-left: 0;
    }

    &-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex-shrink: 0;
        position: relative;
        z-index: 2;

        @media screen and (max-width: 599px) {
            width: 280px;
        }
    }

    &-title {
        color: $white;
        text-align: center;
        margin-bottom: 5px;
        font-size: 30px;
        letter-spacing: -0.94px;

        @media (max-width: 599px) {
            text-align: center;
            width: 100%;
        }
    }

    &-sub {
        color: $white;
        font-size: 16px;
        text-align: center;
        margin-bottom: 20px;

        @media screen and (max-width: 599px) {
            width: 100%;
        }
    }

    &-button {
        @media (max-width: 599px) {
            width: 100%;
        }
    }

    &-image {
        position: relative;

        @media (max-width: 599px) {
            display: none;
        }

        img {
            max-width: 500px;
            max-height: 280px;
        }
    }
}

.top-left {
    .prebuild-section-image {
        right: -75px;

        @media (min-width: 991px) and (max-width: 1200px) {
            right: 35px;
        }
    }
}

.top-right {
    .prebuild-section-image {
        right: 0px;

        @media (min-width: 991px) and (max-width: 1200px) {
            right: 10px;
        }
    }
}

.bottom-left {
    .prebuild-section-image {
        @media (min-width: 991px) and (max-width: 1200px) {
            right: 15px;
        }
    }
}

.bottom-right {
    .prebuild-section-image {
        @media (min-width: 991px) and (max-width: 1200px) {
            right: 80px;
        }
    }
}

</style>
